<template>
  <section class="py-5">
    <div class="container">
      <div class="d-flex align-items-start">
        <AccountOpes />
        <div class="aiz-user-panel">
          <div class="aiz-titlebar mt-2 mb-4">
            <div class="row align-items-center">
              <div class="col-md-6">
                <h1 class="h3">{{ $t("管理个人资料") }}</h1>
              </div>
            </div>
          </div>

          <div v-if="!$route.query.option" class="card">
            <div class="card-header">
              <h5 class="mb-0 h6">{{ $t("基本信息") }}</h5>
            </div>
            <div class="card-body">
              <van-form label-width="120px" @submit="submitInfo">
                <van-field
                  v-model="infoForm.nickName"
                  :label="$t('你的名字')"
                  :placeholder="$t('你的名字')"
                  :rules="[{ required: true, message: $t(`please_input`) }]"
                  class="px-0"
                />
                <van-field
                  v-model="infoForm.phone"
                  :label="$t('手机号码')"
                  :placeholder="$t('手机号码')"
                  :rules="infoForm.phone && [
                    {
                      required: true,
                      message: $t(`请输入手机号码`)
                    },
                    {
                      pattern: /^\d{5,}$/,
                      message: $t('手机号码格式错误'),
                      trigger: 'blur'
                    }
                  ] || []"
                  disabled
                  class="px-0"
                />
                <van-field
                  v-model="infoForm.email"
                  :label="$t('Email')"
                  :placeholder="$t('Email')"
                  class="px-0"
                />
                <van-field :label="$t('照片')" class="px-0">
                  <template #input>
                    <van-uploader :after-read="afterPicRead">
                      <img
                        alt
                        v-if="infoForm.photo"
                        :src="getFileViewUrl(infoForm.photo)"
                        width="130"
                      />
                    </van-uploader>
                  </template>
                </van-field>
                <div class="text-right">
                  <van-button
                    :loading="loadingInfo"
                    :loading-text="$t('submitting')"
                    native-type="submit"
                    type="primary"
                  >
                    {{ $t("submit") }}
                  </van-button>
                </div>
              </van-form>
            </div>
          </div>

          <bank-card-edit v-if="!$route.query.option || $route.query.option === 'userBankCard'" />

          <div  v-if="!$route.query.option || $route.query.option === 'userAddress'" class="card">
            <div class="card-header">
              <h5 class="mb-0 h6">{{ $t("收货地址") }}</h5>
            </div>
            <address-edit />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import AccountOpes from "@/components/AccountOpes.vue";
import BankCardEdit from "@/components/BankCardEdit.vue";
import AddressEdit from "@/components/AddressEdit.vue";

export default {
  components: { AccountOpes, BankCardEdit, AddressEdit },
  data() {
    const userInfo = this.$store.state.user.userInfo;
    return {
      infoForm: {
        nickName: userInfo.nickName,
        phone: userInfo.phone,
        email: userInfo.email,
        photo: userInfo.photo
      },
      loadingInfo: false
    };
  },
  methods: {
    submitInfo() {
      this.loadingInfo = true;
      this.$post("/user/info/update", this.infoForm)
        .then(() => {
          this.loadingInfo = false;
          this.$store.commit("user/UPDATE_ACCOUNT", this.infoForm);
          this.$toast.success(this.$t("save_success"));
        })
        .catch(() => {
          this.loadingInfo = false;
        });
    },
    afterPicRead(file) {
      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("module", "front");
      this.$store.dispatch("common/upload", formData).then(res => {
        this.infoForm.photo = res[0];
      });
    }
  }
};
</script>
